import { orchestrator } from 'satcheljs';
import removePersonaFromWell from '../actions/removePersonaFromWell';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import compareFindRecipientPersonaType from 'owa-recipient-common/lib/utils/compareFindRecipientPersonaType';
import removeReadWriteRecipients from '../actions/removeReadWriteRecipients';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

const removePersonaFromWellOrchestrator = orchestrator(removePersonaFromWell, actionMessage => {
    const { targetRecipientWell, personaToRemove, shouldRemoveAllOccurrences } = actionMessage;
    let elementsToRemove = targetRecipientWell.recipients.filter(
        (value: ReadWriteRecipientViewState) => {
            return compareFindRecipientPersonaType(value.persona, personaToRemove);
        }
    );
    if (elementsToRemove && elementsToRemove.length > 0) {
        const removeTillIndex: number = shouldRemoveAllOccurrences
            ? elementsToRemove.length - 1
            : 0;
        const recipientsToRemove = [];
        for (let index = 0; index <= removeTillIndex; index++) {
            if (!elementsToRemove[index] || elementsToRemove[index].blockWellItemRemoval) {
                continue;
            }
            recipientsToRemove.push(elementsToRemove[index]);
        }

        if (recipientsToRemove.length > 0) {
            removeReadWriteRecipients(targetRecipientWell, recipientsToRemove);
        }
    }
});

export { RecipientWellWithFindControlViewState, FindRecipientPersonaType };

export default removePersonaFromWellOrchestrator;
